import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../services/authStorage";

function ProtectedRoute({ children }) {
  if (!isAuthenticated()) {
    return <Navigate to="/SignIn" replace />;
  }
  return children;
}

export default ProtectedRoute;
